<div class="tiger-level">
  <h1>
    Quaterly Support Table &nbsp;
    <i
      class="pi pi-info-circle"
      style="font-size: 1rem"
      (click)="showDialog()"></i>
  </h1>

  <div class="card">
    <p-chart type="line" [data]="data" [options]="options"></p-chart>
  </div>
</div>

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  <p class="m-0">
    <jni-quarterly-support-table></jni-quarterly-support-table>
  </p>
</p-dialog>
